import CollapsibleActionMenu from '@/components/CollapsibleActionMenu';
import EditSectionNameButton from './EditSectionNameButton';
import SectionGroups from './SectionGroups';
import DeleteSection from './DeleteSection';
import React from 'react';
import SectionVisibilityDates from './SectionVisibilityDates';

type SectionActionsProps = {
  onNameEdit: (event: React.MouseEvent<HTMLLIElement>) => void;
};

const SectionActions = ({ onNameEdit }: SectionActionsProps) => (
  <CollapsibleActionMenu>
    <EditSectionNameButton onClick={onNameEdit} />
    <SectionVisibilityDates />
    <SectionGroups />
    <DeleteSection />
  </CollapsibleActionMenu>
);

export default SectionActions;
